import { render } from "./EdoDocumentDetailsPage.vue?vue&type=template&id=c9bb2e44&scoped=true"
import script from "./EdoDocumentDetailsPage.vue?vue&type=script&lang=js"
export * from "./EdoDocumentDetailsPage.vue?vue&type=script&lang=js"

import "./EdoDocumentDetailsPage.vue?vue&type=style&index=0&id=c9bb2e44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9bb2e44"]])

export default __exports__